import {Component, OnInit} from '@angular/core';
import {
    BmCustomerBillingAccountTransactionObjectBaseComponent
} from "../bm-customer-billing-account-transaction-object-base.component";


@Component({
    selector: 'bm-customer-billing-account-transaction-object-component-side',
    templateUrl: 'bm-customer-billing-account-transaction-object-side.component.html',
    standalone: false
})
export class BmCustomerBillingAccountTransactionObjectSideComponent extends BmCustomerBillingAccountTransactionObjectBaseComponent implements OnInit {


    /**
     * On Object Change. When object is retrieved
     */
    ngOnInit() {
        super.ngOnInit();
    }



}
